import React from 'react';

import { useIntl } from 'react-intl-next';

import SmartUserPicker, {
	type OptionData,
	type Props as SmartUserPickerProps,
} from '@atlaskit/smart-user-picker';

import { CONTRIBUTING_TEAM_PICKER_ID, DEBOUNCE_TIME_MS, MAX_TEAMS } from './constants';
import messages from './messages';
import { NoResultsView } from './no-results-view';

export type TeamOptionData = OptionData;
export type TeamPickerProps = Omit<SmartUserPickerProps, 'fieldId' | 'productKey'> & {
	onTeamSelection?: (teamId: TeamOptionData) => void;
	excludeTeamIds?: string[];
};

export const TeamPicker = ({ onTeamSelection, excludeTeamIds, ...otherProps }: TeamPickerProps) => {
	const { formatMessage } = useIntl();

	return (
		<SmartUserPicker
			{...otherProps}
			fieldId={CONTRIBUTING_TEAM_PICKER_ID}
			productKey="people"
			placeholder={formatMessage(messages.teamPickerPlaceholder)}
			placeholderAvatar="team"
			includeTeams
			includeUsers={false}
			includeGroups={false}
			isMulti={false}
			width="100%"
			maxOptions={MAX_TEAMS}
			debounceTime={DEBOUNCE_TIME_MS}
			onSelection={(option) => {
				if (typeof onTeamSelection === 'function' && option) {
					onTeamSelection(Array.isArray(option) ? option[0] : option);
				}
			}}
			noOptionsMessage={<NoResultsView />}
			filterOptions={(options, filter) =>
				options.filter((option) => {
					if (excludeTeamIds && excludeTeamIds.includes(option.id)) {
						return false;
					}
					return option.name.toLowerCase().includes(filter.toLowerCase());
				})
			}
		/>
	);
};
